import { IAuthConfig, LoginTypes } from '@procom-labs/common'

type LoginTypeMapper = {
  [K in Lowercase<LoginTypes>]: keyof IAuthConfig
}
const mapper: LoginTypeMapper = {
  client: 'client',
  contractor: 'contractor',
  employer: 'employer',
  gorillaresume: 'gorillaResume',
  customer: 'customer',
  support: 'customer',
}

export const LoginTypeUniversalMapper = (
  loginType: string
): keyof IAuthConfig => {
  return mapper[loginType as Lowercase<LoginTypes>]
}
